/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable camelcase */
import React from "react";
import { useMediaQuery } from "beautiful-react-hooks";
import { isSSR } from "../NoSSR";
import classNames from "../../functions/classNames";
import Rating from "../Rating";
import TextExpand from "../TextExpand";
import "./AuthorBio.css";
import { AuthorBioAbout, AuthorBioHeader } from "./AuthorBioComponents";

/**
 * Author biography
 * @param {Object} $
 * @param {String} $.name - name of the author
 * @param {String} $.avatar - URL to avatar of the author
 * @param {String} $.bio - author biography text
 * @param {Number?} $.rating - average rating of the tours created by presented author
 * @param {Number?} $.ratingsCount - amount of the reviews on author tours
 */

export default function AuthorBio(props) {
  const {
    name,
    avatar,
    rating,
    avg_rating,
    reviews_count,
    bio,
    provider,
    year_since,
    user_id,
    ratingsCount,
    place_of_stay,
    languages,
    // products_count, //TODO return products_count when the display of shared tours is added to the backend,
    // regardless of the language
    bioLimit = 262,
    className,
    theme,
    nickname,
    products,
    isOnDemand = false,
  } = props;
  const isMobile = !isSSR && useMediaQuery("(max-width: 767px)");
  const size = isMobile ? "sm" : "lg";
  const finalBioLimit = isMobile ? 24 : bioLimit;

  return (
    <div className={classNames("AuthorBio", `AuthorBio--${theme}`, className)}>
      <AuthorBioHeader
        name={name}
        user_id={user_id}
        avatar={avatar}
        size={size}
        theme={theme}
        rating={rating || avg_rating}
        ratingsCount={ratingsCount || reviews_count}
        year_since={year_since}
        provider={provider}
        isMobile={isMobile}
        nickname={nickname}
      />
      {theme !== "product" && (isMobile || theme !== "card") && (
        <Rating
          theme={theme === "card" ? "main" : "gray"}
          grade={rating || avg_rating}
          count={ratingsCount || reviews_count}
          starsType="small"
          size="large"
          countType="large"
        />
      )}

      {theme === "card" && (
        <AuthorBioAbout
          name={name}
          user_id={user_id}
          // TODO return products_count when the display of shared tours is added to the backend,
          // regardless of the language
          products_count={products.count}
          place_of_stay={place_of_stay}
          languages={languages}
        />
      )}
      {bio && !isOnDemand && (
        <div className="AuthorBio__bio">
          <TextExpand limit={finalBioLimit} fullText={bio} />
        </div>
      )}
    </div>
  );
}
